import React, {useContext} from "react";
import logoMobile from '../../../image/logo/sigle-color.png';
import LogoutIcon from "../../icons/LogoutIcon";
import SessionContext from "../../../context/SessionContext";
import "../../../css/page/HeaderAccess.css";

const HeaderAccess = () => {
    const { handleLogout } = useContext(SessionContext);

    return (
        <header className="header headerAccess">
            <img src={ logoMobile } alt="SkyTill Manager" className="logo" />
            <div className={"logout"} onClick={handleLogout}>
                <LogoutIcon />
                <p className="name">Se déconnecter</p>
            </div>
        </header>
    );
}

export default HeaderAccess;
